import React, { useState, useEffect } from 'react';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [menuOpen]);

  const links = [
    { href: '#hero',      label: 'Home' },
    { href: '#products',  label: 'Products' },
    { href: '#customers', label: 'Customers' },
    { href: '#gallery',   label: 'Farm' },
    { href: '#location',  label: 'Location' },
    { href: '#story',            label: 'Story' },
    { href: '#certifications',  label: 'Certifications' },
    // { href: '#contact',   label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-brand">
        <img src="/logo.jpeg" alt="Adiyogi Natural Farms Logo" className="nav-logo" />
        <span>Adiyogi Natural Farms</span>
      </div>

      {/* Desktop links */}
      <ul className="nav-links">
        {links.map(({ href, label }) => (
          <li key={href}><a href={href}>{label}</a></li>
        ))}
      </ul>

      {/* Hamburger button — mobile only */}
      <button
        className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
        onClick={(e) => { e.stopPropagation(); setMenuOpen((o) => !o); }}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>

      {/* Mobile drawer */}
      <div className={`nav-drawer ${menuOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
        {links.map(({ href, label }) => (
          <a key={href} href={href} onClick={() => setMenuOpen(false)}>{label}</a>
        ))}
      </div>
    </nav>
  );
}
